import { Button, Modal } from '@mairistem/composants';

import { ModalEncaissementTable } from '../Encaissement/ModalEncaissement/ModalEncaissementTable';

const ModalFactureDetail = (props) => {
  const { facture, onClose } = props;

  return (
    <Modal open closeIcon onClose={onClose} size="huge">
      <Modal.Header>
        Détail de la facture N°
        {facture?.numero}
      </Modal.Header>
      <Modal.Content>
        <ModalEncaissementTable factures={[facture]} hideFooter defaultProduitsMontantsVisible />
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-fermer-detail"
          onClick={onClose}
          size="tiny"
          basic
          icon="close"
          content="Fermer"
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalFactureDetail;
